export default __webpack_public_path__ + "static/media/November2008.2fa172f2.png";